import { Controller } from "@hotwired/stimulus"
import { jquery } from 'utils/jquery'
// NProgress is loaded via Sprockets; access it lazily so this module does not
// throw when the global is absent (e.g. pages that don't include the full
// Sprockets bundle).
const nprogress = () => window.NProgress;

export default class extends Controller {
  static targets = ['input']

  connect() {
    let electionId = this.inputTarget.dataset.electionId;
    if (electionId === null || electionId === "") {
      return;
    }
    nprogress()?.start();
    let scrollTopOption = this.inputTarget.dataset.scrollTopOption;
    if (scrollTopOption == 'true') {
      const $ = jquery();
      if ($) {
        $("html, body").animate({ scrollTop: $("#import_options_title").offset().top }, 'slow');
      }
    }
    this.scheduleVoterListProcessingStatusCheck(electionId)
  }

  scheduleVoterListProcessingStatusCheck(electionId) {
    const $ = jquery();
    if (!$) {
      return;
    }

    $.get( `voter_list_import_status/${electionId}`, (processingStatus) => {
      let processingDone = processingStatus && processingStatus.done || false
      let action = processingStatus && processingStatus.action || ""
      if (processingDone) {
        $.get('voter_list_import')
      } else {
        if(action === 'validation') {
          $('#voter_list_processing_message').text('Validating voters.')
        } else if(action === 'importation') {
          $('#voter_list_processing_message').text('Importing and validating voters.')
        } else if(action === 'copy_voters') {
          $('#voter_list_processing_message').text('Copying voters.')
        }
        setTimeout(() => { this.scheduleVoterListProcessingStatusCheck(electionId)}, 500)
      }
    })
  }
}
